import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { BrokerRequest } from "@/types";
import { GET_BROKER_LAST_MESSAGE } from "@/constants";

export const useGetLastBrokerRequest = (enabled?: boolean) =>
  useQuery({
    queryKey: ["broker-last-message"],
    queryFn: () =>
      axios.get<BrokerRequest>(GET_BROKER_LAST_MESSAGE).then((res) => {
        return res.data;
      }),
    refetchOnWindowFocus: false,
    staleTime: 0,
    enabled,
  });
